import Vue from 'vue';
import $ from 'jquery';

Vue.directive('caracteres-email', function(el, binding){
  $(el).on('keypress', function(evt) {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;

    // a - z @ A - Z ; 0-9 . -
    if ((charCode > 96 && charCode < 123) || 
      (charCode > 53 && charCode < 91) || 
      (charCode > 47 && charCode < 58) || 
      charCode === 59 || charCode === 95 || 
      charCode === 46 || charCode === 45) {
      return true;
    } else {
      evt.preventDefault();
    }
  });
});



// WEBPACK FOOTER //
// ./FrontEnd/diretivas/caracteres-email.js